import { render, staticRenderFns } from "./DocumentsNew.vue?vue&type=template&id=24f00253&"
import script from "./DocumentsNew.vue?vue&type=script&lang=js&"
export * from "./DocumentsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports